module.exports = {
  src: __webpack_public_path__ + "assets/images/logout-icon.71f3d9d3ed86b97d.svg",
  width: 20,
  height: 20,
  toString: function() { return __webpack_public_path__ + "assets/images/logout-icon.71f3d9d3ed86b97d.svg"; }
};